import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { ResetPasswordView } from 'views/reset-password';

export const ResetPassword = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.resetPasswordPage',
    });
    
    return (
        <>
            <CustomHeader title={t('title')} />
            <ResetPasswordView />
        </>
    );
};
